import { render, staticRenderFns } from "./placement.vue?vue&type=template&id=5a9fda9e"
import script from "./placement.vue?vue&type=script&lang=js"
export * from "./placement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports